import { useState } from "react";
import { faqs, businessInfo } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="preguntas" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14">
            <div className="lg:col-span-1">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold uppercase tracking-wider mb-5">
                <i className="ri-question-answer-line"></i>
                Preguntas frecuentes
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight tracking-tight">
                Resolvemos tus dudas antes de tu visita
              </h2>
              <p className="mt-5 text-base text-foreground-700 leading-relaxed">
                Y si te queda alguna pregunta, con gusto te atendemos por teléfono. Preferimos que llegues tranquila
                o tranquilo a tu estudio.
              </p>
              <a
                href={businessInfo.phoneLink}
                className="mt-6 inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                Hablemos por teléfono
              </a>
            </div>

            <div className="lg:col-span-2 flex flex-col gap-3">
              {faqs.map((faq, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={faq.question}
                    className={`rounded-lg border transition-colors duration-300 ${
                      isOpen ? "border-primary-300 bg-primary-50" : "border-background-200/80 bg-background-100"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                    >
                      <span className="font-semibold text-foreground-950 text-sm md:text-base leading-snug">
                        {faq.question}
                      </span>
                      <i
                        className={`text-xl flex-shrink-0 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-500"
                        }`}
                      ></i>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}